import feathersClient, { BaseModel, makeServicePlugin } from "../feathers-client";

class Organizations extends BaseModel {
  static modelName = "Organizations";
}

const servicePlugin = makeServicePlugin({
  Model: Organizations,
  service: feathersClient.service("organizations"),
});

export default servicePlugin;
